/* eslint no-console: ["error", { allow: ["error"] }] */
import { t } from 'i18next';

export const generalEnum = (field: string, value: any, enumeration?: any) => {
  let translation;

  if (enumeration) {
    if (value in enumeration) {
      translation = value ? t(`general.enumerations.${field}.${value as string}`) : '-';
    } else {
      console.error(`Value: '${value}' does not exist in enumeration : '${field}' `);
      translation = '-';
    }
    return translation;
  }

  return value ? t(`general.enumerations.${field}.${value as string}`) : '-';
};
